export default __webpack_public_path__ + "static/media/btn_depart_disable.da2ef29c.svg";